import docReady from '../../../assets/js/docReady';
import { logAnalyticsEvent } from '../../../assets/js/helpers/bananas';
function collectFeedback(event) {
    const targetElement = event.target || event.srcElement;
    const feedbackResult = targetElement.dataset.feedback;

    if (feedbackResult === 'neutral') {
        document.querySelector('.thanks-neutral').classList.add('force-show');
    } else if (feedbackResult === 'negative') {
        document.querySelector('.thanks-negative').classList.add('force-show');
    } else if (document.querySelector('.thanks-positive')) { /* not always there */
        document.querySelector('.thanks-positive').classList.add('force-show');
    }

    if (typeof window.bananas !== 'undefined') {
        logAnalyticsEvent('feedback.simple', feedbackResult);
    }

    document.querySelector('.feedback-thanks').classList.add('force-show');
    document.querySelector('.smile-feedback-buttons').classList.add('force-hide');
}

export default function feedbackWatch() {
    docReady(() => {
        const feedbackButtons = document.querySelectorAll('.smile-feedback-buttons .feedback-button');
        feedbackButtons.forEach((feedbackButton) => {
            feedbackButton.addEventListener('click', (event) => {
                collectFeedback(event);
            });
        });
    });
}
